import { render, staticRenderFns } from "./EvaluationConfiguration.vue?vue&type=template&id=54e49e8d&"
import script from "./EvaluationConfiguration.vue?vue&type=script&lang=js&"
export * from "./EvaluationConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports